<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <a class="brand" routerLink="/" (click)="closeIfHandset(drawer)">
      <img class="brand-logo" src="assets/brand/ceads-logo.png" alt="CEADS"/>
      <!-- <span class="brand-sub">Data Space</span> -->
    </a>
    <mat-nav-list>
      <a mat-list-item *ngFor="let route of routes" [routerLink]="[route.path]"
         routerLinkActive="active-link" (click)="closeIfHandset(drawer)">
          <mat-icon matListItemIcon>{{route.data?.icon}}</mat-icon>
          {{route.data?.title ?? route.path}}
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span class="toolbar-title">{{titleService.getTitle()}}</span>
      <span class="spacer"></span>

      <!-- User Profile Dropdown -->
      <button mat-icon-button [matMenuTriggerFor]="userMenu" *ngIf="isLoggedIn()">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item disabled>
          <mat-icon>person</mat-icon>
          {{ getUsername() }}
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          Logout
        </button>
      </mat-menu>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
